import { MessageSeverity } from '@app/components/Messages/types';
import {
  isExpiredProductRemoval,
  isNonsaleableProductRemoval,
  mapCartMessageFromMonolith,
} from '@app/components/Messages/utils';
import { usePaymentRedirectError } from '@app/components/Stripe';
import { useCartAndDeliveryDatesDataContext } from '@app/data/clients/cartCheckoutClient';
import { isAny } from '@app/utils/isAny';
import { useIntl } from '@redbubble/next/intl';
import { useMemo } from 'react';

export const useCartMessages = () => {
  const intl = useIntl();
  const { cart } = useCartAndDeliveryDatesDataContext();

  const { error: paymentRedirectError } = usePaymentRedirectError();
  return useMemo(() => {
    const m = (cart?.messages || [])
      .map(mapCartMessageFromMonolith)
      .filter(isAny([isExpiredProductRemoval, isNonsaleableProductRemoval]));

    if (paymentRedirectError) {
      m.unshift({
        severity: MessageSeverity.Error,
        text:
          typeof paymentRedirectError === 'string'
            ? paymentRedirectError
            : intl.formatMessage(paymentRedirectError),
      });
    }

    return m;
  }, [cart?.messages, paymentRedirectError, intl]);
};
